<div class="detail">
  <div>
    <h1>Dokumenty EPD k zařazení</h1>
  </div>

  <div class="mt-30">
    <gmt-navbar [tabs]="tabs" [isActiveTab]="isActiveTab">
      <div *ngIf="tab === 'documents'">
        <gmt-documents
          *ngIf="documentList && documentList.list"
          [documentList]="documentList"
          [authorizedUser]="canEdit()"
          (updated)="loadDocuments()"
        ></gmt-documents>
      </div>
      <div *ngIf="tab === 'history'">
        <gmt-notes
          [noteList]="historyList"
          [editable]="false"
          type="history"
        ></gmt-notes>
      </div>
    </gmt-navbar>
  </div>
</div>
